export default __webpack_public_path__ + "static/media/DSC0297_Snapseed_Fotor-590448a25f9b5810dcf78a5a.449af9d7.jpg";